const filterItems = {
    'EnhancedData': [
      {value: 'SpeedLimits'},
      {value: 'Curvatures'},
      {value: 'Slopes'}
    ],
    'Adasis': [
      {value: 'Position'},
      {value: 'Stub'},
      {value: 'Segment'},
      {value: 'Profile Short'},
      {value: 'Profile Long'},
      {value: 'Meta-Data'}
    ]
};

export { filterItems };